<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { isSequenceRunning } from 'src/helpers/xt1_helpers/irrigation/irrigation_helpers';
	//Components
	import TemplateSliderSettings from '../Components/TemplateSliderSettings.svelte';
	import IrrigationConfirmModal from './IrrigationConfirmModal.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let confirmModal: IrrigationConfirmModal;
</script>

<Alert
	class="mb-s"
	heading={$format('xt1_alert_irrigation_duration', {
		default: 'Affects all zones',
	})}
/>
<TemplateSliderSettings
	{device}
	{confirmModal}
	setting="duration_offset"
	min={-100}
	max={100}
	title={$format('text_irrigation_durations_offset', {
		default: 'Duration offset',
	})}
/>

{#if isSequenceRunning(device)}
	<IrrigationConfirmModal bind:this={confirmModal} />
{/if}
